import React from "react";
import styled from "styled-components";

const Box = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SmallBox = styled.div`
  width: 100%;
  height: 100%;
  max-width: 500px;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 80px;
`;

const Container = ({ children }) => {
  return (
    <Box>
      <SmallBox>{children}</SmallBox>
    </Box>
  );
};

export default Container;
